import { render } from "./ProductSetting.vue?vue&type=template&id=4e477fd8&scoped=true"
import script from "@/assets/js/product.js?vue&type=script&lang=js&external"
export * from "@/assets/js/product.js?vue&type=script&lang=js&external"

import "@/assets/css/product.css?vue&type=style&index=0&id=4e477fd8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e477fd8"]])

export default __exports__